import React from 'react'
import styled from 'styled-components'
import { atlTheme } from '../../../atlTheme'
import { ATLSpacing, SpacingSizesEnum } from '@appsimples/atlantica-react-native'
import { messages } from '../../../constants/strings/messages'
import { formatMessage } from '../../../constants/strings/intl/intlHooks'
import { windowWidth } from '../../../constants/dimensions'

const Background = styled.div`
  height: fit-content;
  width: ${windowWidth}px;
  background: ${atlTheme.ColorSurface};
  margin-top: ${atlTheme.SpacingAtomic}px;
  padding: ${atlTheme.SpacingBase}px ${atlTheme.SpacingMarginal}px;
  box-sizing: border-box;
`
const MainText = styled.p`
  font-family: ${atlTheme.FontFamilyBrand};
  font-weight: normal;
  font-size: ${atlTheme.FontSizeBody}px;
  line-height: ${atlTheme.LineHeightBase}px;
  color: ${atlTheme.ColorHighContrast};
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  width: 100%;
`

export const PlainInfoComponent: React.FunctionComponent = () => {
  return (
    <Background>
      <MainText>{formatMessage(messages.profileScreen_privacyPolicy_fullText)}</MainText>
      <ATLSpacing type={SpacingSizesEnum.marginal} />
    </Background>
  )
}
